import { CompositeLayer } from '@deck.gl/core';
import { IconLayer, ScatterplotLayer } from '@deck.gl/layers';
import { DEFAULT_MAP_SOURCE } from '@env';

export class FsSvgIconLayer<T> extends CompositeLayer {
  static layerName: string;

  public id: string;
  public layerName: string;

  get defaultMapSource(): string {
    return DEFAULT_MAP_SOURCE;
  }

  constructor(
    public data: {
      id: string;
      data: T[];
      getIcon: (d: T) => { url: string; height: number; width: number; mask: boolean };
      getSize: (d: T) => number;
      getPosition: (d: T) => number[];
      getFillColor: (d: T) => number[];
      getLineColor: (d: T) => number[];
      getLineWidth: (d: T) => number;
      onClick?: (d: T) => any;
      getTooltip?: (d: T) => any;
    },
    layerName: string,
  ) {
    super();
    this.id = this.data.id;
    this.layerName = layerName;
  }

  renderLayers() {
    const {
      data,
      getIcon,
      getSize,
      getPosition,
      getLineColor,
      getLineWidth,
      getFillColor,
      getTooltip,
      onClick,
    } = this.data;

    const iconLayer = new IconLayer({
      id: `icon-layer-${crypto.randomUUID()}`,
      data,
      getIcon,
      getSize,
      getColor: [255, 255, 255],
      getPosition,
      aplhaCutoff: 0,
      sizeScale: 1,
      loadOptions: {
        imagebitmap: {
          resizeWidth: 128,
          resizeHeight: 128,
        },
      },
      onClick,
      getTooltip,
    });

    const scatterplotLayer = new ScatterplotLayer({
      id: `scatterplot-layer-${crypto.randomUUID()}`,
      data,
      getPosition,
      getFillColor,
      getLineColor,
      getLineWidth,
      stroked: true,
      getRadius: 16,
      radiusMinPixels: 16,
      radiusMaxPixels: 16,
      lineWidthMinPixels: 2,
      lineWidthMaxPixels: 2,
      pickable: true,
      onClick,
      getTooltip,
    });

    switch (this.defaultMapSource) {
      case 'esri':
        return [iconLayer, scatterplotLayer];
      case 'google':
      default:
        return [scatterplotLayer, iconLayer];
    }
  }
}

FsSvgIconLayer.layerName = 'FsSvgIconLayer';
